
export class MlDefault {

    static map = {
        center: [35.501701, 38.730519],
        zoom: 16,
        pitch: 70,
        bearing: 0,
        antialias: true
    }


    static baseLayerName = "base-layer"
}

export default MlDefault;
